import React from 'react';
// import { Router } from '@reach/router';
// import { onRouteUpdate } from 'gatsby';
import { Location } from '@reach/router';
import { NavProvider } from './src/context/NavProvider';
import { ConfiguratorProvider } from './src/context/ConfiguratorProvider';

// FOUC
// in use
// export function onClientEntry() {
//   window.addEventListener('load', () => {
//     document.body.className = document.body.className.replace(/\bno-js\b/, '');
//   });
// }
// not in use
// exports.onClientEntry = () => {
//   window.addEventListener('load', () => {
//     document.body.className = document.body.className.replace(/\bno-js\b/, '');
//   });
// };

// for tawk.to widget
const excludedPaths = [
  '/wedding-packages/',
  '/elopement-packages/',
  '/storage-packages/',
  '/packages/checkout/',
];

// add retries to help ensure the tawk.to widget is hidden
// on page refresh
// const handleTawkToWidget = (pathname, retries = 10) => {
//   // console.log('handleTawkToWidget called with pathname:', pathname);
//   if (typeof document !== 'undefined') {
//     if (excludedPaths.includes(pathname)) {
//       // console.log('Hiding Tawk.to widget');
//       const tawkIframes = document.querySelectorAll(
//         'iframe[src*="tawk.to"], iframe[title="chat widget"]'
//       );
//       const tawkDivs = document.querySelectorAll(
//         'div[id^="z"], div[id^="b"], div[id^="w"], div[id^="chat-bubble"]'
//       );

//       if (tawkIframes.length > 0 || tawkDivs.length > 0) {
//         tawkIframes.forEach((iframe) => {
//           iframe.style.display = 'none !important';
//         });
//         tawkDivs.forEach((div) => {
//           div.style.display = 'none !important';
//         });
//       } else if (retries > 0) {
//         // console.log('Retrying to hide Tawk.to widget, retries left:', retries);
//         setTimeout(() => handleTawkToWidget(pathname, retries - 1), 300);
//       }
//     } else {
//       // console.log('Showing Tawk.to widget');
//       const tawkIframes = document.querySelectorAll(
//         'iframe[src*="tawk.to"], iframe[title="chat widget"]'
//       );
//       tawkIframes.forEach((iframe) => {
//         iframe.style.display = 'block';
//         iframe.style.position = 'absolute';
//       });

//       const tawkDivs = document.querySelectorAll(
//         'div[id^="z"], div[id^="b"], div[id^="w"], div[id^="chat-bubble"]'
//       );
//       tawkDivs.forEach((div) => {
//         div.style.display = 'block';
//       });
//     }
//   }
// };

// Fix the blocking iframe - Only when widget is closed
const fixBlockingIframe = () => {
  try {
    const widgetContainer = document.querySelector('.widget-visible');
    if (!widgetContainer) return;

    const iframes = widgetContainer.querySelectorAll('iframe');

    iframes.forEach((iframe) => {
      if (iframe && iframe.style) {
        const width = iframe.style.width;
        const height = iframe.style.height;

        // Target the fullscreen overlay iframes
        const isBlockingOverlay =
          width &&
          height &&
          ((width.includes('100%') && height.includes('100%')) ||
            (width.includes('360px') &&
              (height.includes('545px') || height.includes('520px'))));

        // Target the chat bubble
        const isChatBubble =
          width &&
          height &&
          ((width.includes('67px') && height.includes('64px')) ||
            (width.includes('204px') && height.includes('44px')));

        if (isBlockingOverlay && !isChatBubble) {
          iframe.style.setProperty('display', 'none', 'important');
        } else if (isChatBubble) {
          iframe.style.removeProperty('display');
        }
      }
    });
  } catch (error) {
    // handle errors
  }
};

// Improved tawk.to widget handler
const handleTawkToWidget = (pathname, retries = 15) => {
  if (typeof window === 'undefined') return;

  const shouldHide = excludedPaths.includes(pathname);

  // Method 1: Use Tawk.to API if available
  if (window.Tawk_API && typeof window.Tawk_API.hideWidget === 'function') {
    if (shouldHide) {
      window.Tawk_API.hideWidget();
    } else {
      window.Tawk_API.showWidget();
    }
  }

  // Method 2: Direct DOM manipulation (fallback and for blocking iframe)
  if (typeof document !== 'undefined') {
    const tawkIframes = document.querySelectorAll(
      'iframe[src*="tawk.to"], iframe[title="chat widget"]'
    );
    const tawkDivs = document.querySelectorAll(
      'div[id^="t"], div.widget-visible'
    );

    if (tawkIframes.length > 0 || tawkDivs.length > 0) {
      if (shouldHide) {
        tawkIframes.forEach((iframe) => {
          if (iframe && iframe.style) {
            iframe.style.setProperty('display', 'none', 'important');
          }
        });
        tawkDivs.forEach((div) => {
          if (div && div.style) {
            div.style.setProperty('display', 'none', 'important');
          }
        });
      } else {
        tawkIframes.forEach((iframe) => {
          if (iframe && iframe.style) {
            iframe.style.removeProperty('display');
          }
        });
        tawkDivs.forEach((div) => {
          if (div && div.style) {
            div.style.removeProperty('display');
          }
        });

        // Fix the blocking iframe issue immediately
        fixBlockingIframe();
      }
    } else if (retries > 0) {
      setTimeout(() => handleTawkToWidget(pathname, retries - 1), 300);
    }
  }
};

// Periodically fix the blocking iframe
let blockingIframeInterval = null;

const startBlockingIframeFix = () => {
  // Clear any existing interval
  if (blockingIframeInterval) {
    clearInterval(blockingIframeInterval);
  }

  // Check and fix every 3 seconds, but only if widget is minimized
  blockingIframeInterval = setInterval(() => {
    // Only apply fix if Tawk widget is NOT open
    if (
      window.Tawk_API &&
      typeof window.Tawk_API.isChatMaximized === 'function'
    ) {
      if (!window.Tawk_API.isChatMaximized()) {
        fixBlockingIframe();
      }
    } else {
      // Fallback if API not available - apply the fix
      fixBlockingIframe();
    }
  }, 3000);

  // Also fix immediately (only if closed)
  setTimeout(() => {
    if (
      window.Tawk_API &&
      typeof window.Tawk_API.isChatMaximized === 'function'
    ) {
      if (!window.Tawk_API.isChatMaximized()) {
        fixBlockingIframe();
      }
    } else {
      fixBlockingIframe();
    }
  }, 500);
};

const stopBlockingIframeFix = () => {
  if (blockingIframeInterval) {
    clearInterval(blockingIframeInterval);
    blockingIframeInterval = null;
  }
};

// Lightweight observer specifically for show/hide widget logic
let tawkVisibilityObserver = null;
let lastPathname = null;

const setupTawkVisibilityObserver = (pathname) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  lastPathname = pathname;

  // Clean up existing observer
  if (tawkVisibilityObserver) {
    tawkVisibilityObserver.disconnect();
  }

  // const shouldHide = excludedPaths.includes(pathname);

  // Create observer that only watches for Tawk widget additions
  tawkVisibilityObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          // Check if the added node is Tawk-related
          if (
            node.nodeType === 1 &&
            (node.classList?.contains('widget-visible') ||
              node.id?.startsWith('t') ||
              node.querySelector?.('.widget-visible'))
          ) {
            // Apply show/hide logic immediately when Tawk elements are added
            setTimeout(() => {
              handleTawkToWidget(lastPathname, 3);
            }, 100);
          }
        });
      }
    }
  });

  // Only observe childList changes
  tawkVisibilityObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

const stopTawkVisibilityObserver = () => {
  if (tawkVisibilityObserver) {
    tawkVisibilityObserver.disconnect();
    tawkVisibilityObserver = null;
  }
};

// fix scrolling issue and tawk.to widget
export const onRouteUpdate = ({ location }) => {
  const pathname = location.pathname;

  // handle tawk.to widget
  // NOTE: enabled in prod
  handleTawkToWidget(pathname);

  // Retry a few more times with delays to ensure it works
  setTimeout(() => handleTawkToWidget(pathname, 5), 200);
  setTimeout(() => handleTawkToWidget(pathname, 5), 500);
  setTimeout(() => handleTawkToWidget(pathname, 3), 1000);

  // Start or stop observer and blocking iframe fix based on whether widget should be visible
  if (excludedPaths.includes(pathname)) {
    // Widget is hidden, stop both observer and blocking iframe fix
    stopTawkVisibilityObserver();
    stopBlockingIframeFix();
  } else {
    // Widget is visible, start both observer and blocking iframe fix
    setupTawkVisibilityObserver(pathname);
    startBlockingIframeFix();
  }

  // fix scrolling issues
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  };

  const scrollToHash = () => {
    const hash = location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  // Ensure the scroll action happens after the route update and page content is rendered
  setTimeout(() => {
    requestAnimationFrame(() => {
      if (location.hash) {
        scrollToHash();
      } else {
        scrollToTop();
      }
    });
  }, 0); // add delay to ensure content is rendered if needed
};

// tawk.to widget is hidden on specific pages
// export const onInitialClientRender = () => {
//   // console.log('onInitialClientRender called');
//   setTimeout(() => {
//     handleTawkToWidget(window.location.pathname);
//   }, 375);
// };
export const onInitialClientRender = () => {
  // console.log('onInitialClientRender called');
  const pathname = window.location.pathname;

  setTimeout(() => {
    handleTawkToWidget(pathname);
    setupTawkVisibilityObserver(pathname);

    // Only start blocking iframe fix if widget should be visible
    if (!excludedPaths.includes(pathname)) {
      startBlockingIframeFix();
    }
  }, 500);

  // Also listen for Tawk.to load event
  if (typeof window !== 'undefined') {
    window.addEventListener('tawkLoad', () => {
      handleTawkToWidget(pathname);
    });
  }
};

export const wrapRootElement = ({ element }) => (
  <Location>
    {({ location }) => (
      <ConfiguratorProvider location={location}>
        <NavProvider>{element}</NavProvider>
      </ConfiguratorProvider>
    )}
  </Location>
);

// export function wrapRootElement() { return <Provider />; }
// exports.wrapRootElement = () => <Provider />
// export const wrapRootElement = Provider;
// export default wrapRootElement = Provider;
